export {
  default
} from './route.config';
const _import =  require('../_import_' + process.env.NODE_ENV);

export const PublicApp = _import('Public/App');
export const PublicIndex = _import('Public/Index/index') ;
export const PublicSearchPage = _import('Public/SearchPage/index');
export const PublicBookDetail = _import('Public/bookDetail/index');
export const PublicNewBookRelease = _import('Public/NewBookRelease/index');
//学生查询页面
export const UserStudentMessage = _import('Public/studentMessageNoLogin');
//学生查询页面暂停使用
//export const UserStudentMessage = _import('Public/studentMessageParse');



// WEBPACK FOOTER //
// ./src/views/Public/index.js